import { BestExerciseDetailComponentModule } from './components/best-exercise-detail/best-exercise-detail.component.module';
import { InfoBoxComponentModule } from './components/info-box/info-box.component.module';
import { VideoComponentModule } from 'src/app/components/video/video.component.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

import { HttpClientModule, HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorsInterceptor } from './interceptors/errors.interceptor';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HttpManagerConfig, HttpManagerModule } from 'http-manager';

import { ElectronService } from 'ngx-electron';
import { ModalModule } from 'modal';
import { LoadingConfig, LoadingModule, LoadingErrorsInterceptor, LoadingRequestInterceptor } from 'loading';

import { environment } from 'src/environments/environment';
import { AuthModule, AuthConfig } from 'auth';
import { CrudManagerModule } from 'crud-manager';
import { DialogBoxConfig, DialogBoxModule } from 'dialog-box';
import { ModalBoxModule, ModalBoxButton, ModalBoxEvent, ModalBoxClose } from 'modal-box';
import { VersionBoxConfig, VersionBoxModule } from 'version-box';
import { LanguageTabModule, LanguageTabConfig } from 'language-tab';
import { LocalStorageModule, LocalStorageService } from 'local-storage';
import { ExerciseInfoComponentModule } from './components/exercise-info/exercise-info.component.module';
import { global } from 'common';
import { ExerciseTrackingComponentModule } from './components/exercise-tracking/exercise-tracking.component.module';
import { NumberToTimePipe } from './pipes/number-to-time.pipe';
import { CirclePercentComponentModule } from './components/circle-percent/circle-percent.component.module';
import { ExerciseChecklistEditComponentModule } from './components/exercise-checklist-edit/exercise-checklist-edit.component.module';
import { CirclePercentMarkerComponentModule } from './components/circle-percent-marker/circle-percent-marker.component.module';
import { ScoreInfoComponentModule } from './components/score-info/score-info.component.module';
import { STORAGE_SERVICE_TOKEN } from 'storage';
import { ReplayAnalyzerComponentModule } from './components/replay-analyzer/replay-analyzer.component.module';
import { ReplayAnalizerExportComponentModule } from './components/replay-analizer-export/replay-analizer-export.component.module';
import { ReplayViewerAnalysisComponentModule } from './components/replay-viewer-analysis/replay-viewer-analysis.component.module';
import { IconButtonComponentModule } from './components/icon-button/icon-button.component.module';
import { FormElementsConfig, FormElementsModule } from 'form-elements';
// import { ReplayAnalyzerComponentModule } from './components/replay-analyzer/replay-analyzer.component.module';


global.init();

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule,
            IonicModule.forRoot({animated: false}),
            HttpClientModule,
            AppRoutingModule,
            FormsModule,
            ReactiveFormsModule,
            VideoComponentModule,
            InfoBoxComponentModule,
            BestExerciseDetailComponentModule,
            VideoComponentModule,
            ExerciseInfoComponentModule,
            ExerciseTrackingComponentModule,
            CirclePercentComponentModule,
            CirclePercentMarkerComponentModule,
            IconButtonComponentModule,
            ExerciseChecklistEditComponentModule,
            ModalBoxModule.forRoot(),

            TranslateModule.forRoot({
              defaultLanguage: environment.defaultLanguage,
              loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [/*HttpClient,*/ HttpBackend]
              }
            }),
            LanguageTabModule.forRoot(new LanguageTabConfig({
              endPointService: environment.endPointService,
              activeLanguage: environment.defaultLanguage,
              defaultLanguage:'es',
              localStorageLanguage: 'winco.language'
            })),
            NoopAnimationsModule,
            ModalModule.forRoot(),
            LoadingModule.forRoot(new LoadingConfig({img: "./../assets/images/loader.gif"})),
            FormElementsModule.forRoot(new FormElementsConfig({
              defaultAutocomplete: 'off',
              passwordAutocomplete: 'new-password',
              selectAutocomplete: 'off'
            })),
            AuthModule.forRoot(new AuthConfig({
              endPointService: environment.endPointService,
              localStorageAuthToken: 'winco.aut_token',
              sessionStorageUser: 'winco.user',
              localStorageRemember: 'winco.remember',
              loginFormAutocomplete: 'off',
              loginEmailAutocomplete: 'off',
              loginPasswordAutocomplete: 'new-password',
              recoverFormAutocomplete: 'off',
              recoverEmailAutocomplete: 'off',
              setPasswordFormAutocomplete: 'off',
              setPasswordNewPasswordAutocomplete: 'new-password',
              setPasswordRepeatPasswordAutocomplete: 'new-password'
            })),
            HttpManagerModule.forRoot(new HttpManagerConfig({
              defaultLanguage: environment.defaultLanguage,
              product: environment.product
            })),
            VersionBoxModule.forRoot(new VersionBoxConfig({
              image: "./../assets/images/SVG/winco_isotipo.svg",
              close: new ModalBoxClose({
                event: ModalBoxEvent.CANCEL
              })
            })),
            CrudManagerModule.forRoot(),
            DialogBoxModule.forRoot(new DialogBoxConfig({
              accept: new ModalBoxButton({
                title: 'aceptar',
                event: ModalBoxEvent.ACCEPT
              }),
              cancel: new ModalBoxButton({
                title: 'cancelar',
                event: ModalBoxEvent.CANCEL
              }),
              close: new ModalBoxClose({
                event: ModalBoxEvent.CANCEL
              }),
              successIcon: './../assets/images/SVG/icon_ok.svg',
              warningIcon: './../assets/images/SVG/icon_triangle-orange.svg',
              dangerIcon: './../assets/images/SVG/icon_error.svg',
              contentCss: 'winco-dialog-box-content',
              messageCss: 'winco-dialog-box-message',
              iconCss: 'winco-dialog-box-icon',
              successIconCss: 'winco-dialog-box-icon-success',
              warningIconCss: 'winco-dialog-box-icon-warning',
              dangerIconCss: 'winco-dialog-box-icon-danger'
            })),
            LocalStorageModule.forRoot(),
            ScoreInfoComponentModule,
            ReplayAnalyzerComponentModule,
            ReplayAnalizerExportComponentModule,
            ReplayViewerAnalysisComponentModule
          ],
  providers: [
    ElectronService,
    NumberToTimePipe,
    provideCharts(withDefaultRegisterables()),
    { provide: STORAGE_SERVICE_TOKEN, useExisting: LocalStorageService },

    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingRequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingErrorsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}

// export function HttpLoaderFactory(http: HttpClient)
// {
//   return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
// }

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
     { prefix: './assets/i18n/', suffix: '.json' },//host app i18n assets
     { prefix: './auth/assets/i18n/', suffix: '.json' }, //auth assets
     { prefix: './modal-box/assets/i18n/', suffix: '.json' }, //modal-box assets
     { prefix: './version-box/assets/i18n/', suffix: '.json' }, //version-box assets
     { prefix: './form-elements/assets/i18n/', suffix: '.json' } //version-box assets
   ])
 }


